import {Service} from "@/services/Service";

export class CargaMasivaService extends Service {
    constructor(axios) {
        super(axios, "/empleado");
        // this.fields = [
        //     "username": this.$localStorageService.,
        //     "password": "",
        // ]
    }

    cargarAltaPacientes(nombreEmpleado, numEmpleado, email, nombreCliente, nombreSucursal, turno) {
        this.onStart();

        const params = {
            "nombre_completo": nombreEmpleado,
            "numero_empleado": numEmpleado,
            "email": email,
            "nombre_cliente": nombreCliente,
            "nombre_sucursal": nombreSucursal,
            "nombre_turno": turno
        }

        return this.http.post(this.getUrl(['/registro/carga']), params)
            .then((response) => {
                // console.info("----", response.data);
                return JSON.parse(response.data)
            })
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }
}